/*
 * @Author: your name
 * @Date: 2020-11-17 13:17:36
 * @LastEditTime: 2020-11-26 14:54:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \reader_space_head\src\models\search.js
 */
export default {
  namespace: "search",
  state: {
    searchType: 1,
    searchVal: ''
  },
  reducers: {
    setType(state, action) {
      state.searchType = action.searchType
      return state
    },
    setSearchVal(state, action) {
      state.searchVal = action.searchVal
      return state
    },
  },
}
